import React, { useState, useEffect } from "react"
import ReactModal from "react-modal"

import SvgClose from "../_svgs/small/Close"

import "./_modal.scss"

const Modal = ({
  modifier = "",
  overlayModifier = "",
  bodyModifier = "",
  externalState = false,
  closeHandler = null,
  afterOpenHandler = null,
  noScrollToTop = false,
  hideClose = false,
  isOpen,
  children,
}) => {
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    ReactModal.setAppElement("body")
    if (isOpen) {
      setShowModal(true)
    }
  }, [isOpen])

  useEffect(() => {
    if (externalState && typeof isOpen !== "undefined" && isOpen !== showModal) {
      setShowModal(isOpen)
    }
  }, [externalState, isOpen, showModal])

  const onAfterOpenHandler = (event) => {
    if (!noScrollToTop) window.scrollTo(0, 0)
    window.dispatchEvent(new CustomEvent("modal:render", { detail: { modal: { el: event.contentEl } } }))
    if (afterOpenHandler) {
      afterOpenHandler()
    }
  }

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    if (closeHandler) {
      closeHandler()
    } else {
      setShowModal(false)
    }
  }

  return (
    <div className="modal">
      {!externalState && <button onClick={handleOpenModal}>Trigger Modal</button>}

      <ReactModal
        onRequestClose={handleCloseModal}
        onAfterOpen={onAfterOpenHandler}
        closeTimeoutMS={200}
        isOpen={showModal}
        contentLabel="Minimal Modal Example"
        className={`modal__box ${modifier}`}
        overlayClassName={overlayModifier}
        bodyOpenClassName={bodyModifier}
      >
        {!hideClose && (
          <button className="modal__close" onClick={handleCloseModal}>
            <SvgClose />
          </button>
        )}
        {children}
      </ReactModal>
    </div>
  )
}

export default Modal
